<p-toast></p-toast>
<div class="grid">
    <div class="col-12 md:col-6 lg:col">
        <p-autoComplete [suggestions]="filteredParkingLocations"
            (completeMethod)="filterParkingLocations($event)"
            [(ngModel)]="selectedParkingLocation"
            optionValue="id" optionLabel="name" styleClass="w-full"
            [multiple]="true"
            placeholder="Select a Location"
            [inputStyle]="{'width': '100%'}">
            <ng-template let-location pTemplate="item">
                <div class="flex align-items-center gap-2">
                    <div>{{ location.id }} - {{ location.name }}</div>
                </div>
            </ng-template>
        </p-autoComplete>
    </div>
    <div class="col-12 md:col-6 lg:col">
        <p-multiSelect
        [options]="serviceDropDownOptions"
        [(ngModel)]="selectedService"
        optionLabel="name"
        placeholder="Select a Service(s)"
        styleClass="w-full"/>
    </div>
    <div class="col-12 md:col-6 lg:col-2">
        <p-dropdown
        [options]="intervalDropDownOptions"
        [(ngModel)]="selectedInterval"
        optionLabel="name"
        optionValue="value"
        placeholder="Select a Interval"
        styleClass="w-full" />
    </div>
    <div class="col-12 md:col-6 lg:col">
        <p-calendar [(ngModel)]="searchByRangeDates" [showIcon]="true" [maxDate]="maxDate" selectionMode="range" [readonlyInput]="true" placeholder="Date"
        [showTime]="true" styleClass="w-full"></p-calendar>
    </div>
    <div class="col-12 md:col-6 lg:col">
        <p-button label="Submit" (click)="loadChartData()"/>
    </div>
    <div class="col-12">
        <canvas id="canvas">{{chart}}</canvas>
    </div>
</div>

<router-outlet />